export default defineNuxtPlugin({
    name: 'studio-assistant',
    dependsOn: [],
    setup(nuxtApp)
    {
        if (!isLayerEnabled('studio'))
        {
            return;
        }

        // jawny kanał studio → core: czat AI (warstwa core) renderuje picker po nazwie przez <component :is>
        nuxtApp.vueApp.component('AiAssistantStudioDocumentPicker', defineAsyncComponent(() => import('../components/assistant/AiAssistantStudioDocumentPicker.vue')));
    }
});
